import Skeleton from '@/components/ui/Skeleton'
import { CTA_BODY, CTA_CARD } from '@/screens/courses/components/detail/course-detail-box'

/** Eight rows, the lecture count of a typical course: a longer one is taller, never shorter. */
const ROWS = 8

/**
 * The loaded page's own shape, read off `CourseHead`/the tab strip/the
 * Lectures tab (the default): the level and facts under the title, the tabs,
 * and the bare rows (rest:ln). Its own light module — `Skeleton` and the shared box
 * classes only, no component import — since the route's `pendingComponent`
 * ships in the entry chunk (docs/route-loading.md, Skeletons).
 */
export default function CourseDetailSkeleton() {
  return (
    <>
      <div aria-hidden="true" className="flex flex-col gap-3">
        <div className="flex h-6 items-center">
          <Skeleton className="h-6 w-24 rounded-xs" />
        </div>
        <div className="flex h-5 items-center">
          <Skeleton className="h-4 w-80 max-w-full rounded-xs" />
        </div>
      </div>

      <div aria-hidden="true" className="flex items-center gap-8">
        {['w-16', 'w-16', 'w-16'].map((width, index) => (
          <div key={index} className="flex h-9 items-center">
            <Skeleton className={`h-4 rounded-xs ${width}`} />
          </div>
        ))}
      </div>

      <div
        aria-hidden="true"
        className="divide-y divide-border-subtle border-y border-border-subtle"
      >
        {Array.from({ length: ROWS }, (_, index) => (
          <div key={index} className="flex min-h-13 items-center gap-4 py-4">
            <Skeleton className="h-3 w-4 shrink-0 rounded-xs" />
            <Skeleton className="h-4 w-1/2 rounded-xs" />
          </div>
        ))}
      </div>
    </>
  )
}

/**
 * `CourseCtaCard`'s shape — the buy card's own pending content, in the
 * same column the loaded page draws it in (rest:ln: in the page, no rail).
 */
export function CourseCtaSkeleton() {
  return (
    <div aria-hidden="true" className={CTA_CARD}>
      <Skeleton className="aspect-video w-full rounded-none" />
      <div className={CTA_BODY}>
        <div className="flex flex-col gap-1">
          <div className="flex h-7 items-center">
            <Skeleton className="h-5 w-28 rounded-xs" />
          </div>
          <div className="flex h-4 items-center">
            <Skeleton className="h-3 w-48 rounded-xs" />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-12 w-full rounded-md" />
          <Skeleton className="h-12 w-full rounded-md" />
        </div>
      </div>
    </div>
  )
}
